import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProductResponse} from "../../../models/productResponse";
import {ImageService} from "../../../service/image.service";
import {AttributeValueResponse} from "../../../models/attributeValueResponse";
import {UserService} from "../../../service/user.service";
import {ShoppingCartService} from "../../../service/shoppingCart.service";
import {ShoppingCartRequest} from "../../../models/shoppingCartRequest";
import {Router} from "@angular/router";
import {SharedService} from "../../../service/shered.service";
import {ShoppingSharedService} from "../../../service/shopping-shared.service";

@Component({
  selector: 'app-product-details-dialog',
  templateUrl: './product-details-dialog.component.html',
  styleUrls: ['./product-details-dialog.component.scss', './product-details-dialog-media.component.scss', '../../layouts/product-card/product-card.component.scss']
})
export class ProductDetailsDialogComponent implements OnInit {
  private selectedProductCard!: ProductResponse;
  selectedImage!: string;
  quantity: number = 1;
  selectedColor!: number;
  shoppingCartRequest!: ShoppingCartRequest

  constructor(
    private dialogRef: MatDialogRef<ProductDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private imageService: ImageService,
    private userService: UserService,
    private shoppingCartService: ShoppingCartService,
    private router: Router,
    private sharedService: SharedService,
    private shoppingSharedService: ShoppingSharedService
  ) {
  }

  ngOnInit() {
    this.selectedProductCard = Object.assign({}, this.data.product);
    this.selectedImage = this.selectedProductCard.imageUrls[0];
    this.quantity = this.data.selectedQuantity || 1;
    this.selectedColor = this.data.selectedColor || this.data.product.attributeValues[0]?.value;
  }

  get getProductCard(): ProductResponse {
    return this.selectedProductCard;
  }

  changeSelectedImage(image: string) {
    this.selectedImage = image;
  }

  protected closeDialog(): void {
    this.selectedImage = this.selectedProductCard.imageUrls[0];
    this.dialogRef.close();
  }

  get totalPriceUSD(): number {
    return this.selectedProductCard.convertedPrice * this.quantity;
  }

  get totalPriceAMD(): number {
    return this.selectedProductCard.price * this.quantity;
  }

  increaseQuantity() {
    this.quantity++;
  }

  decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  selectColor(attributeValue: AttributeValueResponse) {
    this.selectedColor = attributeValue.id;
  }

  addToCart() {
    this.shoppingCartRequest = {
      productId: this.data.product.id,
      quantity: this.quantity,
      attributeValueIds: [this.selectedColor],
      isFromOutOfCart: true
    };

    if (this.userService.isLoggedIn()) {
      this.shoppingCartService.addProductToBucket(this.shoppingCartRequest).subscribe({
        next: () => {
          this.sharedService.needToUpdate()
          this.selectedProductCard.isAddedToCart = true;
          setTimeout(() => {
            this.selectedProductCard.isAddedToCart = false;
          }, 2000);
        },
        error: (err) => console.error('Failed to add to cart', err),

      });
    } else {
      this.closeDialog()
      this.userService.setRedirectUrl(this.router.url);
      this.router.navigate(['/login']);
    }
  }

  getProductImageUrl(imageName: string) {
    return this.imageService.getImageUrl(imageName)
  }

  getColorValueById(colorId: number, attributeValues: any[]): string | null {
    const colorAttribute = attributeValues.find(attr => attr.id === colorId);
    return colorAttribute ? colorAttribute.value : null;
  }

  quickShop() {
    if (!this.userService.isLoggedIn()) {
      this.userService.setRedirectUrl(this.router.url);
      this.closeDialog();
      this.router.navigate(['/login']);
      return;
    }

    const selectedColorValue = this.getColorValueById(this.selectedColor, this.selectedProductCard.attributeValues);
    const totalSumAmd = this.totalPriceAMD;
    const totalSumUsd = this.totalPriceUSD;
    const shopData = [{
      product: this.selectedProductCard,
      quantity: this.quantity,
      selectedColor: selectedColorValue ?? '',
      priceAMD: this.totalPriceAMD,
      priceUSD: this.totalPriceUSD
    }];

    this.shoppingSharedService.products = shopData;
    this.shoppingSharedService.totalSumAmd = totalSumAmd;
    this.shoppingSharedService.totalSumUsd = totalSumUsd;

    this.closeDialog();
    this.router.navigate(['/shipping-method'], {
      state: { shopData, totalSumAmd, totalSumUsd }
    });
  }
}
